// extracted by mini-css-extract-plugin
export default {"headline":"rhlcdb","title":"doggB4"};